// @ts-nocheck
import styled from 'styled-components'

import { ballotPropertyPageText } from 'app/components/Ballot/constants'
import { Box } from 'app/components/design-system-components'

const StyledPropertyBallotsWrapper = styled(Box)`
  width: 50%;
  @media screen and (max-width: 992px) {
    width: 100%;
  }
`

const PropertyBallots = ({ teamSlug = '' }) => {
  return (
    <StyledPropertyBallotsWrapper width="50%">
      <Box mb={5}>{ballotPropertyPageText(teamSlug)}</Box>
    </StyledPropertyBallotsWrapper>
  )
}

export default PropertyBallots
